import React, { useEffect, useState } from 'react';

const LINKS = [
  { label: 'Aerveil', href: '#aerveil' },
  { label: 'Experience', href: '#experience' },
  { label: 'Work', href: '#work' },
  { label: 'Publications', href: '#publications' },
  { label: 'Film', href: '#film' },
  { label: 'Contact', href: '#contact' },
];

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Prevent the page scrolling behind the open mobile sheet.
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ease-calm ${
        scrolled ? 'bg-night/90 backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      <nav className="shell flex h-16 items-center justify-between md:h-20">
        <a
          href="#top"
          className="font-mono text-xs uppercase tracking-eyebrow text-cream transition-colors duration-300 hover:text-amber-bright"
        >
          Ishita Srivastava
        </a>

        <ul className="hidden items-center gap-7 lg:flex">
          {LINKS.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="link-underline font-mono text-[0.7rem] uppercase tracking-eyebrow text-cream/70 hover:text-cream"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          className="flex h-10 w-10 items-center justify-center lg:hidden"
        >
          <span className="relative block h-3 w-5">
            <span
              className={`absolute left-0 block h-px w-5 bg-cream transition-all duration-300 ease-calm ${
                open ? 'top-1.5 rotate-45' : 'top-0'
              }`}
            />
            <span
              className={`absolute left-0 block h-px w-5 bg-cream transition-all duration-300 ease-calm ${
                open ? 'top-1.5 -rotate-45' : 'top-3'
              }`}
            />
          </span>
        </button>
      </nav>

      {/* Mobile sheet */}
      <div
        className={`overflow-hidden bg-night/95 backdrop-blur-md transition-[max-height] duration-500 ease-calm lg:hidden ${
          open ? 'max-h-[32rem]' : 'max-h-0'
        }`}
      >
        <ul className="shell flex flex-col gap-1 py-6">
          {LINKS.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={() => setOpen(false)}
                className="block border-b border-cream/10 py-3 font-mono text-xs uppercase tracking-eyebrow text-cream/75 transition-colors duration-300 hover:text-amber-bright"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
};

export default Navigation;
